module.exports = __webpack_public_path__ + "static/media/github.1bb02710.svg";